gambleModeButton = {};

gambleModeButton.create = function () {
  var button = new PIXI.Container();

  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    if (!gdk.getPlatformAllowsGamble()) return false;

    return !gameController.inFreespins;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    var allow = this._flags.canSpin && !this._flags.autoplayStarted && !this._flags.modal.active;

    button.buttonContainer.alpha = allow ? 1 : 0.3;

    return allow;
  };

  button.onConfig = function (config) {
    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return gdk.getPlatformAllowsGamble();
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));
    messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
    messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    button.modeFive = resourceManager.get('buttonContainer:buttonBar:gambleModeButton:button:buttonFive');
    button.modeOn = resourceManager.get('buttonContainer:buttonBar:gambleModeButton:button:buttonOn');
    button.modeOff = resourceManager.get('buttonContainer:buttonBar:gambleModeButton:button:buttonOff');

    button.buttonContainer = resourceManager.get('buttonContainer:buttonBar:gambleModeButton');

    button.modes = [button.modeFive, button.modeOn, button.modeOff];
    button.sounds = ['gambleX5', 'gambleOn', 'gambleOff'];

    button.switchMode(gameController.gambleModeIndex);
  };

  button.setRecovery = function () {};

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPressedCallback = function () {
    button.switchMode(gameController.switchGambleMode(), true);
  };

  button.switchMode = function (mode, pressed = false) {
    button.modes.forEach((sprite) => {
      sprite.visible = false;
    });

    button.modes[mode].visible = true;

    if (pressed) {
      soundManager.play(button.sounds[mode]);
    }
  };

  return button;
};

gambleModeButton.initialise = function (json, object) {
  object.setupResources();
};

gambleModeButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'gambleModeButton',
  gambleModeButton.create,
  gambleModeButton.initialise,
  gambleModeButton.getFilesRequired
);
